import { render, staticRenderFns } from "./AgentInfo_bak.vue?vue&type=template&id=5ec74c06&scoped=true"
import script from "./AgentInfo_bak.vue?vue&type=script&lang=js"
export * from "./AgentInfo_bak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec74c06",
  null
  
)

export default component.exports